var exports = {
  "container": "x9bf38834--b48247--container",
  "wrapper": "x9bf38834--b48247--wrapper",
  "title": "x9bf38834--b48247--title",
  "description": "x9bf38834--b48247--description",
  "btn": "x9bf38834--b48247--btn",
  "img": "x9bf38834--b48247--img",
  "tablet": "x9bf38834--b48247--tablet",
  "phone": "x9bf38834--b48247--phone",
};

module.exports = exports;
